import { CardWithC3CssProps } from './CssConfig';

export const offerConfigs = [
  {
    componentReference: 'title',
    label: 'Offers',
    id: 'offers-holder',
    cssProps: {
      width: '100%',
      display: 'block',
    },
  },

  //cards set 1
  {
    componentReference: 'container',
    id: 'offers-cards-container',
    children: [
      {
        containerType: 'offers',
        componentType: 'card',
        componentReference: 'card',
        id: 'offer_created',
        selected: false,
        cssProps: CardWithC3CssProps,
        ui: {
          renderType: 'card',
          header: 'applied',
          id: 'applied',
          value: 50,
          topLabel: 'Offers created',
          bottomLabel: 'OFFERS',
          // hoverLabel: 'Total number of applications received from candidates',
          // tag: 'Based on tag data',
        },
        api: {
          subject_type: 'offers',
          metadata: {
            tileKey: 'offer_created',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'offers',
            id: 'offer_created',
          },
        },
      },
      {
        containerType: 'offers',
        componentType: 'card',
        componentReference: 'card',
        id: 'offer_time_to_offer',
        selected: false,
        cssProps: CardWithC3CssProps,
        ui: {
          renderType: 'card',
          header: 'interviewed',
          id: 'interviewed',
          value: '15 Days',
          // compareValue: 63,
          // percentageDiff: 75,
          // trend: 'up',
          // comparisonLabel: 'vs previous 8 days',
          topLabel: 'Time to offer',
          bottomLabel: 'TIME',
          // hoverLabel: 'Total number of interviews conducted with candidates',
          // tag: 'Based on tag data',
        },
        api: {
          subject_type: 'offers',
          metadata: {
            tileKey: 'offer_time_to_offer',
            componentType: 'card',
            apiParam: 'card',
            unit: 'time',
            // headerKey: 'time_to_offer',
            id: 'offer_time_to_offer',
            calculationType: 'avgChange',
            metricKeys: {
              numerator: 'time_to_offer',
              denominator: 'offers',
            },
          },
        },
      },
      {
        containerType: 'offers',
        componentType: 'card',
        componentReference: 'card',
        id: 'offer_revision_per_offer',
        selected: false,
        cssProps: CardWithC3CssProps,
        ui: {
          renderType: 'card',
          header: 'offer',
          id: 'offer',
          value: 13,
          topLabel: 'Avg. revisions per offer',
          bottomLabel: 'OFFER REVISIONS',
          // hoverLabel: 'Total number of job offers issued to candidates',
          // tag: 'Based on tag data',
        },
        api: {
          subject_type: 'offers',
          metadata: {
            tileKey: 'offer_revision_per_offer',
            componentType: 'card',
            apiParam: 'card',
            calculationType: 'avgChange',
            metricKeys: {
              numerator: 'revisions_on_offer',
              denominator: 'offers',
            },
            id: 'offer_revision_per_offer',
          },
        },
      },
    ],
  },
  //cards set 2
  {
    componentReference: 'container',
    id: 'offers-cards-container-set1',
    children: [
      {
        containerType: 'offers',
        componentType: 'card',
        componentReference: 'card',
        id: 'accepted_offers',
        selected: false,
        cssProps: CardWithC3CssProps,
        ui: {
          renderType: 'card',
          header: 'interviewed',
          id: 'interviewed',
          value: '23',
          // compareValue: 63,
          // percentageDiff: 75,
          // trend: 'up',
          // comparisonLabel: 'vs previous 8 days',
          topLabel: 'Offers accepted',
          bottomLabel: 'TIME',
          // hoverLabel: 'Total number of interviews conducted with candidates',
          // tag: 'Based on tag data',
        },
        api: {
          subject_type: 'offers',
          metadata: {
            tileKey: 'accepted_offers',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'accepted_offers',
            id: 'accepted_offers',
          },
        },
      },
      {
        containerType: 'offers',
        componentType: 'card',
        componentReference: 'card',
        id: 'offer_acceptance_rate',
        selected: false,
        cssProps: CardWithC3CssProps,
        ui: {
          renderType: 'card',
          header: 'interviewed',
          id: 'interviewed',
          value: '44%',
          // compareValue: 63,
          // percentageDiff: 75,
          // trend: 'up',
          // comparisonLabel: 'vs previous 8 days',
          topLabel: 'Offer acceptance rate',
          bottomLabel: 'Unit',
          // hoverLabel: 'Total number of interviews conducted with candidates',
          // tag: 'Based on tag data',
        },
        api: {
          subject_type: 'offers',
          metadata: {
            tileKey: 'offer_acceptance_rate',
            componentType: 'card',
            apiParam: 'card',
            calculationType: 'rateOfChange',
            unit: 'percent',
            metricKeys: {
              numerator: 'accepted_offers',
              denominator: 'offers',
            },
            id: 'offer_acceptance_rate',
          },
        },
      },
      {
        containerType: 'offers',
        componentType: 'card',
        componentReference: 'card',
        id: 'rejected_offers',
        selected: false,
        cssProps: CardWithC3CssProps,
        ui: {
          renderType: 'card',
          header: 'interviewed',
          id: 'interviewed',
          value: '16',
          // compareValue: 63,
          // percentageDiff: 75,
          // trend: 'up',
          // comparisonLabel: 'vs previous 8 days',
          topLabel: 'Offers rejected',
          bottomLabel: 'TIME',
          // hoverLabel: 'Total number of interviews conducted with candidates',
          // tag: 'Based on tag data',
        },
        api: {
          subject_type: 'offers',
          metadata: {
            tileKey: 'rejected_offers',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'rejected_offers',
            id: 'rejected_offers',
          },
        },
      },
    ],
  },

  //trend chart
  {
    containerType: 'offers',
    componentType: 'chart',
    componentReference: 'chart',
    id: 'offers_trend_chart',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Offer trend',
      id: 'offers_trend_chart',
      chartData: {
        categories: ['2023-Q4', '2024-Q1', '2024-Q2', '2024-Q3', '2024-Q4'],
        series: [0, 0, 0, 117, 43],
      },
      chartType: 'column',
    },
    api: {
      subject_type: 'offers',
      metadata: {
        tileKey: 'offers_trend_chart',
        componentType: 'chart',
        apiParam: 'chart_table',
        headerKeys: [],
        id: 'offers_trend_chart',
      },
    },
  },

  //visual chart 1 & Chart 2
  {
    componentReference: 'container',
    id: 'offers-chart-container1',
    children: [
      {
        containerType: 'offers',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'offers_department_chart',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Offers by department ',
          id: 'offers_department_chart',
          chartData: {
            series: [
              {
                name: 'QA',
                y: 11,
              },
              {
                name: 'GTM',
                y: 8,
              },
              {
                name: 'ORS Partners',
                y: 2,
              },
              {
                name: 'Exec',
                y: 24,
              },
              {
                name: 'Accessbility',
                y: 2,
              },
              {
                name: 'BE',
                y: 1,
              },
              {
                name: 'Platform',
                y: 2,
              },
              {
                name: 'Product',
                y: 2,
              },
            ],
          },
          chartType: 'pie',
        },
        api: {
          subject_type: 'offers',
          metadata: {
            tileKey: 'offers_department_chart',
            componentType: 'chart',
            apiParam: 'visual',
            defaultFilters: {
              group_by_1: 'department',
            },
            headerKeys: [],
            id: 'offers_department_chart',
          },
        },
      },
      {
        containerType: 'offers',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'offers_location_chart',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Offers by location',
          id: 'offers_location_chart',
          chartData: {
            series: [
              {
                name: 'Dubai',
                y: 8,
              },
              {
                name: 'Paris',
                y: 9,
              },
              {
                name: 'HQ',
                y: 11,
              },
              {
                name: 'No location',
                y: 8,
              },
              {
                name: 'DEV Center',
                y: 2,
              },
              {
                name: 'kula hq final',
                y: 8,
              },
              {
                name: 'Ch, India',
                y: 2,
              },
              {
                name: 'Kula Dubai',
                y: 3,
              },
              {
                name: 'Kula US',
                y: 1,
              },
            ],
          },
          chartType: 'pie',
        },
        api: {
          subject_type: 'offers',
          metadata: {
            tileKey: 'offers_location_chart',
            componentType: 'chart',
            apiParam: 'visual',
            defaultFilters: {
              group_by_1: 'appl_location',
            },
            headerKeys: [],
            id: 'offers_location_chart',
          },
        },
      },
    ],
  },

  //table
  {
    containerType: 'offers',
    componentType: 'table',
    componentReference: 'table',
    id: 'offers_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Offer breakdown',
      id: 'offers_table',
      tableData: [
        {
          ds: '0',
          dt: '2023-Q4',
          header: '2023-Q4',
          g1: null,
          g2: null,
          offers: 0,
          time_to_offer: 0,
          accepted_offers: 0,
          time_to_close_offer: 0,
          offers_total: 157,
          offers_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q1',
          header: '2024-Q1',
          g1: null,
          g2: null,
          offers: 0,
          time_to_offer: 0,
          accepted_offers: 0,
          time_to_close_offer: 0,
          offers_total: 157,
          offers_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q2',
          header: '2024-Q2',
          g1: null,
          g2: null,
          offers: 0,
          time_to_offer: 0,
          accepted_offers: 0,
          time_to_close_offer: 0,
          offers_total: 157,
          offers_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q3',
          header: '2024-Q3',
          g1: null,
          g2: null,
          offers: 117,
          time_to_offer: 179529179,
          accepted_offers: 14,
          time_to_close_offer: 26709437,
          offers_total: 157,
          offers_per: '74.5',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q4',
          header: '2024-Q4',
          g1: null,
          g2: null,
          offers: 40,
          time_to_offer: 34464086,
          accepted_offers: 7,
          time_to_close_offer: 1148706,
          offers_total: 157,
          offers_per: '25.5',
          subRows: [],
        },
      ],
    },
    api: {
      subject_type: 'offers',
      metadata: {
        tileKey: 'offers_table',
        componentType: 'table',
        apiParam: 'chart_table',
        filters: {
          group_by_1: { id: null, label: 'Time', key: 'dt' },
          group_by_2: { id: null, label: 'None' },
        },
        headerKeys: [
          'offers_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        id: 'offers_table',
      },
    },
  },
];

export const offersLayoutConfig = [
  {
    key: 'offer_created',
    x: 0,
    y: 0,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'offer_time_to_offer',
    x: 4,
    y: 0,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'offer_revision_per_offer',
    x: 8,
    y: 0,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'accepted_offers',
    x: 8,
    y: 7,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'offer_acceptance_rate',
    x: 8,
    y: 14,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'rejected_offers',
    x: 8,
    y: 21,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'offers_trend_chart',
    x: 0,
    y: 7,
    w: 8,
    h: 21,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'offers_department_chart',
    x: 0,
    y: 28,
    w: 6,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'offers_location_chart',
    x: 6,
    y: 28,
    w: 6,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'offers_table',
    x: 0,
    y: 51,
    w: 12,
    h: 18,
    minW: 8,
    minH: 8,
    maxW: 12,
    maxH: 100,
  },
];
